import React from 'react';
import { string, shape, bool } from 'prop-types';
import AdaptiveCruiseControlSphere from '../../../../assets/images/drive_assist/adaptive_cruise_control_sphere';
import AttentionAssistSphere from '../../../../assets/images/drive_assist/attention_assist_sphere';
import AutomaticEmergencyBrakingSphere from '../../../../assets/images/drive_assist/automatic_emergency_braking_sphere';
import AutomaticParkingSphere from '../../../../assets/images/drive_assist/automatic_parking_sphere';
import BlindSpotCheckSphere from '../../../../assets/images/drive_assist/blind_spot_check_sphere';
import EcallSphere from '../../../../assets/images/drive_assist/ecall_sphere';
import LaneSupportSphere from '../../../../assets/images/drive_assist/lane_support_sphere';
import ParkingAidSphere from '../../../../assets/images/drive_assist/parking_aid_sphere';
import PedestrianAndBicycleDetectionSphere from '../../../../assets/images/drive_assist/pedestrian_detection_sphere';
import AdaptiveLightsSphere from '../../../../assets/images/drive_assist/adaptive_lights_sphere';

const LoadingDriveAssistIcons = ({
  type,
  className,
  colors,
  checked = true,
}) => {
  switch (type) {
    case 'adaptive_cruise_control_sphere':
    case 'adaptive_cruise_control':
      return (
        <AdaptiveCruiseControlSphere
          className={className}
          colors={colors}
          checked={checked}
        />
      );
    case 'attention_assist_sphere':
    case 'attention_assist':
      return (
        <AttentionAssistSphere
          className={className}
          colors={colors}
          checked={checked}
        />
      );
    case 'automatic_emergency_braking_sphere':
      return (
        <AutomaticEmergencyBrakingSphere
          className={className}
          colors={colors}
          checked={checked}
        />
      );
    case 'pedestrian_and_bicycle_detection':
      return (
        <PedestrianAndBicycleDetectionSphere
          className={className}
          colors={colors}
          checked={checked}
        />
      );
    case 'automatic_parking_sphere':
    case 'automatic_emergency_braking':
      return (
        <AutomaticParkingSphere
          className={className}
          colors={colors}
          checked={checked}
        />
      );
    case 'blind_spot_check_sphere':
    case 'blind_spot_control':
      return (
        <BlindSpotCheckSphere
          className={className}
          colors={colors}
          checked={checked}
        />
      );
    case 'ecall_sphere':
      return (
        <EcallSphere className={className} colors={colors} checked={checked} />
      );
    case 'lane_support_sphere':
    case 'lane_assist':
      return (
        <LaneSupportSphere
          className={className}
          colors={colors}
          checked={checked}
        />
      );
    case 'parking_aid_sphere':
    case 'parking_aid':
      return (
        <ParkingAidSphere
          className={className}
          colors={colors}
          checked={checked}
        />
      );
    case 'intelligent_lighting_system':
      return (
        <AdaptiveLightsSphere
          className={className}
          colors={colors}
          checked={checked}
        />
      );
    default:
      return <p style={{ fontSize: '1rem' }}>[No Icon found]</p>;
  }
};

LoadingDriveAssistIcons.defaultProps = {
  type: '',
};

LoadingDriveAssistIcons.propTypes = {
  type: string,
  className: string,
  colors: shape(),
  checked: bool,
};

export default LoadingDriveAssistIcons;
